module.exports = __webpack_public_path__ + "img/yjaq.d277ab5e.png";